//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import markdownToTxt from 'markdown-to-txt'
import Footer from '@/components/HomePage/HomePageFooter'
import Post from '@/components/Blog/Post'

export default {
  components: {
    Footer,
    Post,
  },
  async asyncData(ctx) {
    const post = await ctx.$strapi.$http.$get('/posts?slug=' + ctx.params.slug)
    const posts = await ctx.$strapi.$http.$get('/posts?_limit=2')
    posts.forEach((post) => {
      post.body = markdownToTxt(post.body)
    })
    return {
      post: post[0],
      posts,
      postUrl: process.env.baseUrl + '/blog/' + ctx.params.slug,
    }
  },
  data() {
    return {
      post: null,
      posts: [],
      postUrl: '',
    }
  },
  methods: {
    copyUrl() {
      navigator.clipboard.writeText(this.postUrl)
      this.$buefy.toast.open({
        message: 'URL copiada',
        type: 'is-success',
      })
    },
  },
}
